import { isFeatureEnabled, FeatureFlag } from 'src/featureFlags';

import { MenuItemConfig } from '../Menu/types';

/**
 * Opens a URL in a new browser tab with security attributes
 * Prevents window.opener vulnerabilities by setting noopener,noreferrer
 * @param url - The URL to open
 */
const openLink = (url: string) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) {
    newWindow.opener = null; // Additional security measure
  }
};

/**
 * Configuration for the HelpMenu component
 * Contains demo video link and support ticket templates for FridaCentral
 */
export const helpMenuConfig: MenuItemConfig[] = [
  {
    id: 'help',
    label: 'Help',
    submenu: [
      {
        id: 'get-started',
        label: 'Get Started',
        onClick: () => openLink('https://quip-amazon.com/6gtpAbPnGaa9/Frida-Tool-Onboarding-SOP'),
      },
      {
        id: 'demo',
        label: 'Demo',
        onClick: () => openLink('https://broadcast.amazon.com/videos/1689100'),
      },
    ],
  },
  {
    id: 'support',
    label: 'Support',
    submenu: [
      {
        id: 'bug-report',
        label: 'Report Bug',
        onClick: () =>
          openLink(
            'https://t.corp.amazon.com/create/templates/88de82ab-ce76-4647-a941-704d2cb61c6c',
          ),
      },
      {
        id: 'feature-request',
        label: 'Feature Request',
        onClick: () =>
          openLink(
            'https://t.corp.amazon.com/create/templates/04e8a1b6-16f4-4e32-b8df-84236e76583a',
          ),
      },
    ],
  },
  ...(isFeatureEnabled(FeatureFlag.EmbeddedMode)
    ? [
        {
          id: 'tools',
          label: 'Tools',
          submenu: [
            {
              id: 'rodeo-bridge-demo',
              label: 'Rodeo Bridge Demo',
              onClick: () => openLink('https://broadcast.amazon.com/videos/1883892'),
            },
            {
              id: 'rodeo-bridge',
              label: 'Install Rodeo Bridge',
              onClick: () => {
                const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
                if (!isFirefox) {
                  alert(
                    'The Rodeo Bridge currently only supports Firefox. Please open Frida in Firefox to install.',
                  );
                  return;
                }
                openLink(`${window.location.origin}/scripts/rodeo-frida-bridge.user.js`);
              },
            },
          ],
        },
      ]
    : []),
];
